import React, { useEffect, useState } from "react";

import { connect, useDispatch } from "react-redux";

import NavLeft from "./navLeft";
import PageCheckAccount from "./pageCheckAccount";
import PageOtpVerification from "./pageOtpVerification";
import PageTypeAccount from "./pageTypeAccount";
import PageUploadCard from "./pageUploadCard";
import PageCaptureImage from "./pageCaptureImage";
import PageUploadOrganization from "./pageUploadOrganization";
import PageVerify from "./pageVerify";
import PageSuccess from "./pageSuccess";
import PageAccountDetailPersonal from "./pageAccountDetailPersonal";
import PageAccountDetailOrganization from "./pageAccountDetailO";
import PagePreviewPersonal from "./pagePreviewPersonal";

import { setToast } from "../client/actions";
import { makeGetDataAccount } from "../../lib/selector";
import { useHistory } from "react-router";

import GroupDot from "../../assets/img/new/group-dot.png";

// import DetectRTC from "detectrtc";

function Register1({ match: { params }, dataAccount }) {
  const [ocrData, setOcrData] = useState(null);
  const history = useHistory();

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (DetectRTC.isWebRTCSupported === false) {
  //     alert(
  //       "Quý khách dùng Chrome, Firefox hoặc Microsoft Edge để được support tốt nhất.",
  //     );
  //   }
  // }, []);

  function _handleOcrResult(_params) {
    setOcrData(_params);
    history.push("/open-account/complete-info");
  }

  function _handleOrganizationResult(_params) {
    setOcrData(_params);
    history.push("/open-account/complete-info");
  }

  const _handleToast = (msg, type = "info") => {
    const toastMsg = {
      id: Math.random(),
      type,
      title: "Thông báo",
      msg,
    };
    dispatch(setToast(toastMsg));
  };

  return (
    <div className="w-100 theme-bg d-flex">
      {params?.typeId !== "check-info" &&
        params?.typeId !== "success" &&
        params?.typeId !== "preview" && (
          <>
            <img src={GroupDot} alt="" className="gr-dot-top" />
            <NavLeft step={params?.typeId} />
            <img src={GroupDot} alt="" className="gr-dot-bottom" />
          </>
        )}
      {/* content-block */}
      <div className="w-100">
        {params?.typeId === "check-info" && <PageCheckAccount />}
        {params?.typeId === "verify-otp" && <PageOtpVerification />}
        {params?.typeId === "type-account" && <PageTypeAccount />}
        {params?.typeId === "personal" && (
          <PageUploadCard
            dataAccount={dataAccount}
            _handleToast={_handleToast}
            ocrResult={_handleOcrResult}
          />
        )}

        {params?.typeId === "organization" && (
          <PageUploadOrganization
            dataAccount={dataAccount}
            _handleToast={_handleToast}
            organizationResult={_handleOrganizationResult}
          />
        )}
        {params?.typeId === "complete-info" && (
          <>
            {/* {(!dataAccount?.C_TYPE || dataAccount?.C_TYPE === "personal") &&
              !ocrData?.hasOwnProperty("anheKyC") && (
                <PageCaptureImage
                  dataAccount={dataAccount}
                  ocrData={ocrData}
                  _handleToast={_handleToast}
                  ekycResult={_handleOcrResult}
                />
              )} */}
            {(!dataAccount?.C_TYPE || dataAccount?.C_TYPE === "personal") && (
              <PageAccountDetailPersonal
                ocrData={ocrData}
                _handleToast={_handleToast}
              />
            )}
            {dataAccount?.C_TYPE === "business" && (
              <PageAccountDetailOrganization
                ocrData={ocrData}
                _handleToast={_handleToast}
              />
            )}
          </>
        )}

        {params?.typeId === "verify" && (
          <PageVerify _handleToast={_handleToast} />
        )}
        {params?.typeId === "preview" && (
          <PagePreviewPersonal _handleToast={_handleToast} />
        )}
        {params?.typeId === "success" && <PageSuccess />}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  return {
    dataAccount: getDataAccount(state),
  };
};

export default connect(mapStateToProps)(Register1);
